<template>
	<el-header class="header" height="60px">
    	<div class="left">
			<h1>{{schoolName}}</h1>
			<i class="el-icon-sort" @click="changeSchool()"></i>
		</div>
		<div class="right" @click="logout()">
			<i class="el-icon-switch-button"></i>&nbsp;&nbsp;退出
		</div>
    </el-header>
</template>

<script>
	export default {
	    name: "Header",
		data() {
			return {
				schoolName:localStorage.getItem("schoolName")
			}
		},
		methods: {
			logout(){
				localStorage.clear();
				this.$router.push({path: '/'});
			},
			changeSchool(){
				this.$router.push({path: '/schoolList'});
			}
		}
	}
</script>

<style lang="less">
	.header{
		background-color: rgb(84, 92, 100);
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		z-index: 999;
		.left{
			h1{
				color: hsla(0,0%,100%,.8);
    			font-weight: 600;
				display: inline-block;
				font-size: 24px;
				margin: 0 40px;
				margin-left: 40px;
			}
			i{
				color: #FFFFFF;
				font-size: 24px;
				cursor: pointer;
			}
		}
		.right{
			color: #FFFFFF;
			margin-right: 40px;
			font-size: 18px;
			i{
				vertical-align: text-top;
			}
		}
	}
</style>